import { createSlice } from "@reduxjs/toolkit";

const InitialValue = {
  userLoggedIn: false,
  translatorState: true,
};

const UserStatusSlice = createSlice({
  name: "userStatus",
  initialState: InitialValue,
  reducers: {
    setUserLoginStatus: (state, action) => {
      state.userLoggedIn = action.payload;
    },
    setTranslatorState: (state, action) => {
      state.translatorState = action.payload;
    }
  },
});

export const { setUserLoginStatus, setTranslatorState } = UserStatusSlice.actions;
export default UserStatusSlice.reducer;
